import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IcdCodeResponse, IcdCodeState } from "./index.types";

export const initialIcdCodeState: IcdCodeState = {
  count: 0,
  next: null,
  icdCodes: [],
  previous: null,
  icdCodesOptions: [],
  isIcdCodeLoading: false,
};

const name = "icdCode";

export const icdCodeSlice = createSlice({
  name,
  initialState: initialIcdCodeState,
  reducers: {
    getIcdCode: (state) => {
      state.isIcdCodeLoading = true;
    },
    getIcdCodeSuccess: (state, action: PayloadAction<IcdCodeResponse>) => {
      state.isIcdCodeLoading = false;
      state.count = action.payload.count;
      state.next = action.payload.next;
      state.previous = action.payload.previous;
      state.icdCodes = action.payload.results?.length ? action.payload.results : state.icdCodes;
      state.icdCodesOptions = action.payload.results?.length
        ? action.payload.results.map((s) => ({
            label: s.icd_code,
            value: s.id,
            description: s.description,
          }))
        : state.icdCodesOptions;
    },
    getIcdCodeFail: (state) => {
      state.icdCodes = [];
      state.icdCodesOptions = [];
      state.isIcdCodeLoading = false;
    },
    clearIcdCode: (state) => {
      state.icdCodes = [];
      state.icdCodesOptions = [];
      state.isIcdCodeLoading = false;
    },
  },
});

export const { getIcdCode } = icdCodeSlice.actions;

export default icdCodeSlice.reducer;

export const getIcdCodeList = (searchQuery: string) => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/icds/search/?q=${searchQuery}`,
  },
  type: "getIcdCode",
});
